// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchButton_wrapper__99o0G","button":"SearchButton_button__HuYRt"};